export const buildGameSummary = (game) => ({
    gameId: game.gameId,
    description: game.gameRuleSetName,
    hostName: game.hostHandle,
    hostUserId: game.hostUserId,
    createDate: game.createDate,
    status: game.status,
    playerCount: game.players.length,
    maxPlayers: game.maxPlayers,
    gameRuleSetName: game.gameRuleSetName,
});
//# sourceMappingURL=GameSummary.js.map